import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UserDefinedFieldViewModel } from "@tylertech/tyler-api-types";

import { Activatable } from "../../interfaces/userDefinedField";

@Component({
    selector: "user-defined-field-menu",
    templateUrl: "./userDefinedFieldMenu.tmpl.html",
    standalone: false
})
export class UserDefinedFieldMenuComponent
{
    @Input("fields")
    private readonly _fields: Array<UserDefinedFieldViewModel & Activatable>;

    @Output() readonly addNewField = new EventEmitter<UserDefinedFieldViewModel & Activatable>();

    get userDefinedFields(): Array<UserDefinedFieldViewModel & Activatable>
    {
        return this._fields.filter(x => !x.Active && x.IsVisible);
    }

    onClick(field: UserDefinedFieldViewModel & Activatable): void
    {
        this.addNewField.emit(field);
    }
}
